import React, { useRef, useEffect } from "react"

import styled from "styled-components"
import css from "../../lib/styled-system/css"

import Popper from "@mui/material/Popper"
import Grow from "@mui/material/Grow"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import MenuList from "@mui/material/MenuList"
import MenuItem from "@mui/material/MenuItem"

import Box from "../atoms/Box"
import Card from "../atoms/Card"
import { Text } from "../atoms/Typography"

const StyledMenuItem = styled(MenuItem)`
  font-size: 14px !important;
  &:hover {
    ${props =>
      css({
        ...props.hover,
      })}
  }
`

const StyledMenuList = styled(MenuList)`
  & span {
    ${css({ color: "text" })}
  }

  overflow-y: auto;
  ${props =>
    css({
      maxHeight: props.maxHeight,
    })}
`

const PopperMenu = ({
  show: open,
  options,
  anchorEl,
  onSelect,
  location,
  active,
  handleClose,
  card,
  alignMenuItems = "center",
  menuListMaxHeight = "auto",
  filterTextDisplay = "truncated",
}) => {
  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault()
      handleClose()
    }
  }

  const handlePopupItemStyle = () => {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: filterTextDisplay === "truncated" ? "270px" : "100%",
      whiteSpace: "nowrap",
      display: "inline-block",
      width: "100%",
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false && anchorEl?.focus) {
      anchorEl.focus()
    }

    prevOpen.current = open
  }, [open, anchorEl])

  const handlePopupPlacement = alignmentStr => {
    switch (alignmentStr) {
      case "center":
        return "bottom"
      case "left":
        return "bottom-start"
      case "right":
        return "bottom-end"
      default:
        return "bottom-start"
    }
  }
  return (
    <Popper
      style={{ zIndex: 100 }}
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      placement={handlePopupPlacement(location)}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" || placement === "bottom-start"
                ? "center top"
                : "center bottom",
            marginTop: "1px",
          }}
        >
          <Card mt={-6} minWidth={14} {...card}>
            <ClickAwayListener onClickAway={handleClose}>
              <StyledMenuList
                autoFocusItem={open}
                onKeyDown={handleListKeyDown}
                maxHeight={menuListMaxHeight}
              >
                {options?.map((option, idx) => (
                  <Box key={idx} my={2}>
                    <StyledMenuItem
                      disableRipple={true}
                      onClick={() => {
                        onSelect(option)
                        handleClose()
                      }}
                      hover={{ bg: `background.${(card.bg + 1) % 5}` }}
                    >
                      <Text
                        fontWeight={active === option ? "bold" : null}
                        textAlign={
                          alignMenuItems === "left"
                            ? "left"
                            : alignMenuItems === "right"
                              ? "right"
                              : "center"
                        }
                        px={3}
                        fontSize={1}
                        {...handlePopupItemStyle()}
                      >
                        {option}
                      </Text>
                    </StyledMenuItem>
                  </Box>
                ))}
              </StyledMenuList>
            </ClickAwayListener>
          </Card>
        </Grow>
      )}
    </Popper>
  )
}

export default PopperMenu
